import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../shared/sharedData';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom }from '../shared/services/http.client';
import { Auth } from '../shared/services/auth';
import { Router } from '@angular/router';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import * as _ from 'underscore';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'AddSupervisor',
  templateUrl: 'addSupervisor.html'
})

export class AddSupervisor {
  selectedAll: any;
  public localState: any;
  public nl = 1;
  public programData: any;
  public selectedCheckBox: Boolean;
  public comments: any;
  public _baseUrl: any;
  public changeApproverBean = {
    comments: null,
    scorecardId: null,
    employeeId: null,
    secondarySupervisorIds: [],
    primarySupervisorId: null,
    verifierId: null
  }

  public changeApproverBeanList = [];
  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public translate: TranslateService,
    public _auth: Auth,
    public router: Router,
    public _share: SharedData,
    public _toaster: ToasterComponent, vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get("EPMS_BASE_URL");
    this.programData = this._share.getData();
    // this._toaster.setViewRef(vcr);
    this.getData();
  }

  getData() {
    _.each(this.programData.scorecardData, function (key, val) {
      key.selected = false;
    })
  }

  public getScorecardId(scorecardData: any, $event) {
    this.changeApproverBean = null;
    let changeApproverBean1 = {
      comments: null,
      scorecardId: null,
      employeeId: null,
      secondarySupervisorIds: [],
      primarySupervisorId: null,
      verifierId: null
    }
    if ($event.target.checked) {
      changeApproverBean1.employeeId = this.programData.empData.id;
      changeApproverBean1.scorecardId = scorecardData.scorecardId;
      changeApproverBean1.primarySupervisorId = this.programData.empData.primarySupervisorId;
      changeApproverBean1.verifierId = this.programData.empData.verifierId;
      changeApproverBean1.secondarySupervisorIds = this.programData.empData.secSupervisorIds;
      this.changeApproverBeanList.push(changeApproverBean1);
    } else {
      if (this.changeApproverBeanList.length > 0) {
        for (let i of this.changeApproverBeanList) {
          if (i.scorecardId == scorecardData.scorecardId) {
            const index: number = this.changeApproverBeanList.indexOf(i);
            if (index !== -1) {
              this.changeApproverBeanList.splice(index, 1);
            }
            console.log(i);
          }
        }
      }
    }
  }


  public changeApprover() {
    let self = this;
    if (this.changeApproverBeanList.length > 0) {
      if (this.comments == null) {
        this.translate.get('provideComments').subscribe((msg) => {
          this._toaster.showError(msg);
        })

        return false;
      }
      for (let i of this.changeApproverBeanList) {
        i.comments = this.comments;
      }
      let url = self._baseUrl + "v1/webAdmin/employee/updateApprover";
      self.http.post(url, this.changeApproverBeanList).subscribe((result) => {
        if (result) {
          this.translate.get('approved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
          })
          this.activeModal.close(result);
        } else {
          this.translate.get('updateFailed').subscribe((msg) => {
            this._toaster.showError(msg);
          })
        }
      });
    } else {
      this.activeModal.close(true);
    }
  }



  selectAll(event) {
    for (var i = 0; i < this.programData.scorecardData.length; i++) {
      this.programData.scorecardData[i].selected = this.selectedAll;
      this.getScorecardId(this.programData.scorecardData[i], event);
    }
    


  }
  checkIfAllSelected(scorecardData: any, $event) {
    this.selectedAll = this.programData.scorecardData.every(function (item: any) {
      return item.selected == true;
    });
    this.getScorecardId(scorecardData, $event);
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/addSupervisor.ts